import { render, staticRenderFns } from "./ModuleFunction.vue?vue&type=template&id=295d6655&"
import script from "./ModuleFunction.vue?vue&type=script&lang=js&"
export * from "./ModuleFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports